import script from "./ActiveSurveysBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ActiveSurveysBox.vue?vue&type=script&setup=true&lang=js"

import "./ActiveSurveysBox.vue?vue&type=style&index=0&id=1d09cd06&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2025-january\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d09cd06"]])

export default __exports__